import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { API } from '../App';

// Cache defaults tuned for a "feels-instant-on-revisit" UX:
// - staleTime 60s: revisiting a page within 60s skips refetch entirely,
//   returning cached data synchronously so no spinner flashes.
// - gcTime 10min: cached results live in memory for 10 minutes before GC.
// - refetchOnWindowFocus/Mount: disabled so navigating back never shows a
//   skeleton when data is already present.
// - retry: 1 for transient network hiccups; keep failures fast and obvious.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});

// Small fetcher that pairs with `useQuery({ queryKey: [path, params], queryFn: apiGet })`
// so queryKeys double as URL + params. Keeps call sites terse.
export const apiGet = async ({ queryKey }) => {
  const [path, params] = queryKey;
  const res = await axios.get(`${API}${path}`, {
    params: params || undefined,
    withCredentials: true,
  });
  return res.data;
};

// Warm the cache for a given endpoint. Safe to call from hover handlers or
// component mount — returns immediately if data is already fresh.
export const prefetchApi = (path, params) =>
  queryClient.prefetchQuery({ queryKey: [path, params], queryFn: apiGet });
